export default __webpack_public_path__ + "static/media/text.2ccde177.ttf";